import React, { useState } from 'react';

import AssetLibrary from '../../../../shared/components/AssetLibrary/AssetLibrary';
import AssetService from '../../../../shared/services/AssetService';
import Grid from '@mui/material/Unstable_Grid2';
import IconButton from '@mui/material/IconButton';
import ImageIcon from '@mui/icons-material/Image';
import { InlineTextEdit } from '../../InlineTextEdit';
import Paper from '@mui/material/Paper';
import { SorterItem } from '../../../models/LessonComponentContent';
import { nanoid } from 'nanoid';
import styles from '../../../styles/Sorter.module.css';

interface SorterItemEditorProps {
  item?: SorterItem; //* optional for new item
  onSave: (item: SorterItem) => void;
}

export function SorterItemEditor(props: SorterItemEditorProps) {
  const [showAssetLibrary, setShowAssetLibrary] = useState(false);

  function handleShowAssetLibrary() {
    setShowAssetLibrary(true);
  }

  function handleSaveItemLabel(label: string) {
    const item = props.item
      ? { ...props.item, label }
      : { label, id: nanoid(), image: null };
    props.onSave(item);
  }

  function handleAssetSelect(assetkey: string) {
    const item = props.item
      ? { ...props.item, image: assetkey }
      : { label: '', id: nanoid(), image: assetkey };
    props.onSave(item);
  }

  function handleCloseAssetLibrary() {
    setShowAssetLibrary(false);
  }

  return (
    <>
      <Grid container alignItems="center">
        <Grid className={styles.gridStretch}>
          <Paper elevation={2} className={styles.sorterItem}>
            <Grid container alignItems="center">
              <Grid
                className={styles.gridStretch}
                style={{ marginRight: props.item?.image ? '10px' : '5px' }}
              >
                <InlineTextEdit
                  value={props.item?.label || ''}
                  style={{ fontSize: '17px', display: 'block' }}
                  placeholder={
                    props.item?.image
                      ? 'Click to edit item label'
                      : 'Click to add an item'
                  }
                  onChange={handleSaveItemLabel}
                />
              </Grid>
              <Grid>
                {props.item?.image ? (
                  <img
                    className={styles.sorterItemThumbnail}
                    src={AssetService.getAssetUrl(props.item.image)}
                    onClick={handleShowAssetLibrary}
                  />
                ) : (
                  <IconButton size="small" onClick={handleShowAssetLibrary}>
                    <ImageIcon />
                  </IconButton>
                )}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      {showAssetLibrary && (
        <AssetLibrary
          types={['image']}
          category="author"
          title="Select Image"
          selectedAssetkey={props.item?.image}
          onSelect={handleAssetSelect}
          onClose={handleCloseAssetLibrary}
        />
      )}
    </>
  );
}
